/**
 * Shared Google Maps JS API loader options.
 * @react-google-maps/api throws if useJsApiLoader is called with mismatched options.
 */
import { useCallback, useSyncExternalStore } from "react";

export const TRUSTCHAT_GOOGLE_MAPS_LOADER_ID = "trustchat-maps";

let authFailed = false;
const authFailureListeners = new Set();

/**
 * Without `gm_authFailure` Google paints its own "This page can't load Google
 * Maps correctly" modal every time a map instance is created, so remounting a
 * map (switching chats) makes the dialog flash. Taking over the callback keeps
 * the failure inside React so each map can render its own inline placeholder.
 */
if (typeof window !== "undefined" && !window.gm_authFailure) {
  window.gm_authFailure = () => {
    authFailed = true;
    authFailureListeners.forEach((listener) => listener());
  };
}

function subscribeToAuthFailure(listener) {
  authFailureListeners.add(listener);
  return () => {
    authFailureListeners.delete(listener);
  };
}

function getAuthFailureSnapshot() {
  return authFailed;
}

export function useGoogleMapsAuthFailed() {
  const subscribe = useCallback(subscribeToAuthFailure, []);
  return useSyncExternalStore(
    subscribe,
    getAuthFailureSnapshot,
    getAuthFailureSnapshot
  );
}

export function getTrustchatGoogleMapsLoaderOptions(apiKey) {
  return {
    id: TRUSTCHAT_GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey: (apiKey || "").trim(),
  };
}
